import {
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import _ from 'lodash';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/components/dialog/confirm-dialog/confirm-dialog.component';
import { ApprovalAssessments } from 'src/app/models/proofreading.model';
import { MemberStatus } from 'src/app/models/projects/submodels/members.model';
import { ProofreadingService } from 'src/app/services/proofreading.service';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { ExternStatePayloadFlag } from 'src/app/models/states.model';
import { MembersService } from 'src/app/services/member.service';
import { ViewComponent } from 'src/app/shared/pages/view/view.component';
import { LoaderService } from 'src/app/services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProofreadingMember } from 'src/app/models/proofreading-member.model';


@Component({
    selector: 'app-members-proofreading',
    templateUrl: './members-proofreading.component.html',
    styleUrls: ['./members-proofreading.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MembersProofreadingComponent extends ViewComponent {
    @Input() hideHeader?: boolean = false;

    get MEMBER_STATUS() {
        return MemberStatus;
    }

    @Input() public readonly: boolean = false;

    get hasOrder() {
        return !!this._members.filter(m => !_.isNil(m.order)).length;
    }

    protected _current_order: number = 0;
    @Input() set current_order(value: number) {
        this._current_order = value;
    };
    get current_order(): number {
        return this._current_order;
    }

    protected _members: ProofreadingMember[];
    @Input() set members(value: ProofreadingMember[]) {
        this._members = value;
    };
    // get members(): ProofreadingMember[] {
    //     return (this.hasOrder? this._members.sort((m, m2) => (m.order || 0) - (m2.order || 0)) : this._members) || [];
    // }


    get members(): ProofreadingMember[] {
        if (!this.hasOrder) return this._members || [];

        return this._members
            .filter(m => m.hasApproDocument || !m.hasApproDocument)
            .sort((m, m2) => {
                return (Number(!m2.hasApproDocument) - Number(!m.hasApproDocument)) * -1 ||
                    ((m.order || 0) - (m2.order || 0));
            });
    }

    get current_member() {
        return this.s_members.current_member;
    }

    get can_approve(): boolean {
        const state = this.s_proofreadings.current?.state;
        return this.s_auth.isCPP()
            || this.s_auth.isFab()
            || (state?.hasPayloadFlag(ExternStatePayloadFlag.CUSTOMER_CAN_APPROVE) && this.current_member?.hasApproDocument)
            || (state?.hasPayloadFlag(ExternStatePayloadFlag.CUSTOMER_INFO_CAN_APPROVE) && this.current_member?.hasApproInfo);
    }

    constructor(
        protected s_route: ActivatedRoute,
        protected s_router: Router,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected s_alert: AlertService,
        protected s_proofreadings: ProofreadingService,
        protected s_members: MembersService,
        public dialog: MatDialog,
        protected translate: TranslateService
    ) {
        super(s_route, s_router, s_alert, s_loader, s_auth);
    }

    can_approve_on_behalf(member: ProofreadingMember): boolean {
        return this.s_auth.isCPP() || (!_.isEqual(this.current_member?.usersID, member.usersID) && this.current_member?.hasApproDocument) || false;
    }

    // Clic sur APPROVE
    // Dialog APPROVE
    onApprove(member: ProofreadingMember) {
        this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'DIALOG.ASSESSMENT.APPROBATION',
                text: 'DIALOG.ASSESSMENT.APPROBATION_TXT',
                valid: 'YES',
                noConfirm: false
            }
        }).afterClosed().subscribe(async res => {
            // this.approvalSend = true;
            if (res) {
                await this.assessment(member, ApprovalAssessments.ACCEPT);
            }
        });
    }

    // Clic sur REJECT
    // Dialog REJECT
    onReject(member: ProofreadingMember) {
        this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'DIALOG.ASSESSMENT.REJECT',
                text: 'DIALOG.ASSESSMENT.REJECT_TXT',
                valid: 'YES',
                noConfirm: false
            }
        }).afterClosed().subscribe(async res => {
            if (res) {
                await this.assessment(member, ApprovalAssessments.REJECT);
            }
        });
    }


    async assessment(member: ProofreadingMember, assessments: ApprovalAssessments) {
        if (member.hasApproDocument) {
            console.log("[APPROVAL CLIENT]", assessments, member?.usersID);
            await this.s_proofreadings.approvalClient(assessments, member.usersID);
        }
        else if (member.hasApproInfo) {
            console.log("[APPROVAL INFO]", assessments, member);
            await this.s_proofreadings.approvalInfo(assessments, member.usersID);
        } else {
            this.s_alert.error('[ERROR] No permission to approve or reject');
        }
    }
}

